module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcCAYAAACdz7SqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEuSURBVHgBxZeBbYMwEEW/mYANSjfIBmWDjtB0gnaDthMkG5BMUHWDdIKwQd0JygbXfzFITpTEmIB50hcWBh6WsH0Y9EBEch6WzAOzYAqvu2Ys88XsjDEWt0BZwVQSR6X3YQi88YX5k+G8xchy5lPGQZ+T95HuZVz2IeFKpmF1SbiUaSk7l/GkPzieCmNjOZ3utZF1owwIN6aF7W1En0/RepyUPOE6v17bRvSdcvBk4j7pEmko1acjXSAt5RzSQqXhFWNc8gwzoNIGaWlUapGWWqU7pKXOuJA0CcVaWTTdh7QNXHx3oR3qO+XgmW/Bb3nGtHycPcvRrmUa1tfeJn250krTF2ae/F2Go6XrK4YgrtjeSByVBIpt01cOt9E/wk0rfzu0cL8W33ClS3At/wcPiJM7oYbzLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_stop.png
// module id = w8eX
// module chunks = 1